import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import GasList from './components/GasList'


const { Cell } = ResponsiveGrid;

const Gas = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="瓦斯抄錶列表"
        breadcrumbs={[
          {
            name: '瓦斯抄錶',
          },
          {
            name: '瓦斯抄錶列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <GasList />
    </Cell>
  </ResponsiveGrid>
);

export default Gas;
